import { Button, message, Modal } from 'antd';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import parse from 'emailjs-mime-parser';
import { nullSafeGetOrElse, stopDefaultEvents } from '../../utils/DataAccessUtils';

const EmailOriginModal: FC<any> = ({ s3Url, onCancel }): React.ReactElement => {
	const [textContent, setTextContent] = useState('');

	useEffect(() => {
		const fetchTextFromS3 = async () => {
			try {
				const response = await fetch(s3Url);
				if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

				const text = await response.text();
				setTextContent(text);
			} catch (error) {
				console.error('Error fetching text:', error);
				setTextContent('Failed to load original.');
			}
		};

		if (s3Url) fetchTextFromS3();
	}, [s3Url]);

	const parsedHeaders = useMemo(() => {
		if (!textContent) return {};

		const uint8 = new TextEncoder().encode(textContent);
		const mime = parse(uint8);

		const messageId = nullSafeGetOrElse('headers.message-id.0.value', mime, 'N/A');
		const createdAt = nullSafeGetOrElse('headers.date.0.initial', mime, 'N/A');
		const from = nullSafeGetOrElse('headers.from.0.initial', mime, 'N/A');
		const to = nullSafeGetOrElse('headers.to.0.initial', mime, 'N/A');
		const subject = nullSafeGetOrElse('headers.subject.0.initial', mime, 'N/A');

		return {
			messageId,
			createdAt,
			from,
			to,
			subject,
		};
	}, [textContent]);

	const onDownload = useCallback(
		(e) => {
			stopDefaultEvents(e);
			window.open(s3Url);
		},
		[s3Url]
	);

	const onCopy = useCallback(async () => {
		try {
			await navigator.clipboard.writeText(textContent);
			message.success('Copied successfully!');
		} catch (err) {
			message.error('Failed to copy: ', err);
		}
	}, [textContent]);

	return (
		<Modal
			visible={true}
			width="90%"
			title="Orignal Message"
			closable
			onCancel={onCancel}
			forceRender
			footer={null}
		>
			<table style={{ width: '100%', borderCollapse: 'collapse' }}>
				<tbody>
					<tr>
						<td>
							<strong>Message ID</strong>
						</td>
						<td style={{ color: 'green' }}>{parsedHeaders.messageId}</td>
					</tr>
					<tr>
						<td>
							<strong>Created at:</strong>
						</td>
						<td>{parsedHeaders.createdAt} (Delivered after 0 seconds)</td>
					</tr>
					<tr>
						<td>
							<strong>From:</strong>
						</td>
						<td>{parsedHeaders.from}</td>
					</tr>
					<tr>
						<td>
							<strong>To:</strong>
						</td>
						<td>{parsedHeaders.to}</td>
					</tr>
					<tr>
						<td>
							<strong>Subject:</strong>
						</td>
						<td style={{ fontWeight: 'bold' }}>{parsedHeaders.subject}</td>
					</tr>
				</tbody>
			</table>
			<div className="my-4 flex flex-row items-center justify-between">
				<Button type="link" onClick={onDownload}>
					Download Original
				</Button>
				<Button type="primary" onClick={onCopy}>
					Copy to clipboard
				</Button>
			</div>
			<pre>{textContent}</pre>
		</Modal>
	);
};

export default EmailOriginModal;
